<ng-container *ngIf="!(datosRecibidos1); else datosCargados">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-template #datosCargados>
    <div *ngIf="hayAlarmasActivadas" class="fade-in-container">
        <div class="header-table header-table-background">
            <div class="alarmas-activas-header">
                <mat-icon>warning</mat-icon>&nbsp;&nbsp;<span class="font500">ALARMAS ACTIVAS</span>
            </div>
        </div>
        <div class="bdy-table">
            <table mat-table [dataSource]="dataSourceAlarmsActivas" matSort #sort2="matSort">
    
                <ng-container matColumnDef="f_inicio">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Inicio </th>
                    <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
                </ng-container>
    
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                    <td mat-cell *matCellDef="let element" class="cell"> {{element.type}} </td>
                </ng-container>
    
                <ng-container matColumnDef="rango">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                    <td mat-cell *matCellDef="let element" class="cell"> {{element.rango}} </td>
                </ng-container>
    
                <!--<ng-container matColumnDef="alarmRange">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                    <td mat-cell *matCellDef="let element" class="cell"> {{element.alarmRange}} </td>
                </ng-container>-->
    
                <tr mat-header-row *matHeaderRowDef="displayedColumnsActivas"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsActivas;"></tr>
            </table>
        </div>
    </div>

    <div class="table" class="mat-elevation-z8">
        <div class="table-header">
            <div class="header-content">
                <span class="header-grande">{{dev_label}}&nbsp;
                    <span class="font500 font20 marginRight10">(ID: {{dev_reference}})&nbsp;</span>
                    <span class="font400 font20 marginRight10">TIEMPO REAL&nbsp;</span>
                </span>
                <img src="assets/images/realtime.gif" alt="Icon"/>
                <div class="sol-icons-container">
                    <div class="sol-icon">
                        <mat-icon>wb_sunny</mat-icon>&nbsp;&nbsp;{{temperaturaAmbiente}}&nbsp;ºC
                    </div>
                    <div class="sol-icon1">
                        <mat-icon class="storeIcon">devices_other</mat-icon> <!--&nbsp;&nbsp;{{temperaturaAmbiente}}&nbsp;ºC-->
                    </div>
                </div>
            </div>
            <div class="ultimo-historico">
                <span>{{fechaDelUltimoHistorico}}</span>
            </div>
        </div>
        <div class="table-body">
            <div class="row-tanque1" *ngIf="verT1"> 
                <div class="imagen-tanque1">
                    <div *ngIf="imagenCervezaT1 !== null">
                        <img
                            src="{{tanksInfo[0].imagenCervezaURL}}" 
                            alt="Tipo de cerveza"
                            class="img-css"
                    />
                    </div>
                    <div *ngIf="imagenCervezaT1 === null" class="not-found-img">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                    <div class="numero-tanque1">
                        <img src="assets/images/tanque-eg.png" alt="Tanque 1" [ngClass]="{'imagen-con-borde': condicionT1Activo}"/>
                        <div class="numero-tanque">{{numeroTanque1}}</div>
                    </div>
                    <div class="Consumidos">Consumos del día: <span class="font500">{{devolverConsumoEnTanque(dispositivoId[0], 1)}} Litros</span></div>
                </div>
                <div class="g-N1 altura-titulo">
                    <canvas id="nivelTanque1" data-type="radial-gauge"></canvas>
                    <ng-container *ngIf="tanksInfo[0].recargaNecesaria && (userServiceData.pro_id == 4 || userServiceData.pro_id == 2)">
                        <button mat-fab class="recarga-btn" matTooltip="Solicitar Recarga" aria-label="Solicitar Recarga" 
                        (click)="solicitarRecarga(tanksInfo[0].tank_id, tanksInfo[0].establishment_id)"
                        [disabled]="waitAfterSave">
                            <mat-icon>autorenew</mat-icon>
                        </button>
                    </ng-container>
                    <div *ngIf ="gaugesCargados" class="datos">{{nivelT1}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Nivel</div>
                </div>
                <div class="g-T1 altura-titulo">
                    <canvas id="temperaturaTanque1" data-type="radial-gauge"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{temperaturaT1}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Temperatura</div>
                </div>
                <div class="g-P1 altura-titulo">
                    <canvas id="presionTanque1" data-type="radial-gauge"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{presionT1}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Presión</div>
                </div>
            </div>
            <div class="row-tanque2" *ngIf="verT2">
                <div class="imagen-tanque2">
                    <div *ngIf="imagenCervezaT2 !== null">
                        <img
                            src="{{imagenCervezaT2Url}}" 
                            alt="Tipo de cerveza"
                            class="img-css"
                    />
                    </div>
                    <div *ngIf="imagenCervezaT2 === null" class="not-found-img">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                    <div class="numero-tanque1">
                        <img src="assets/images/tanque-eg.png" alt="Tanque 2" [ngClass]="{'imagen-con-borde': condicionT2Activo}"/>
                        <div class="numero-tanque">{{numeroTanque2}}</div>
                    </div>
                    <div class="Consumidos">Consumos del día: <span class="font500">{{devolverConsumoEnTanque(dispositivoId[0], 2)}} Litros</span></div>
                </div>
                <div class="g-N2 altura-titulo">
                    <canvas id="nivelTanque2"></canvas>
                    <ng-container *ngIf="tanksInfo[1].recargaNecesaria && (userServiceData.pro_id == 4 || userServiceData.pro_id == 2)">
                        <button mat-fab class="recarga-btn" matTooltip="Solicitar Recarga" aria-label="Solicitar Recarga"
                        (click)="solicitarRecarga(tanksInfo[1].tank_id, tanksInfo[1].establishment_id)"
                        [disabled]="waitAfterSave">
                            <mat-icon>autorenew</mat-icon>
                        </button>
                    </ng-container>
                    <div *ngIf ="gaugesCargados" class="datos">{{nivelT2}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Nivel</div>
                </div>
                <div class="g-T2 altura-titulo">
                    <canvas id="temperaturaTanque2"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{temperaturaT2}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Temperatura</div>
                </div>
                <div class="g-P2 altura-titulo">
                    <canvas id="presionTanque2"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{presionT2}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Presion</div>
                </div>
            </div>
            <div class="row-tanque3" *ngIf="verT3">
                <div class="imagen-tanque3">
                    <div *ngIf="imagenCervezaT3 !== null">
                        <img
                            src="{{imagenCervezaT3Url}}" 
                            alt="Tipo de cerveza"
                            class="img-css"
                        />
                    </div>
                    <div *ngIf="imagenCervezaT3 === null" class="not-found-img">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                    <div class="numero-tanque1">
                        <img src="assets/images/tanque-eg.png" alt="Tanque 3" [ngClass]="{'imagen-con-borde': condicionT3Activo}"/>
                        <div class="numero-tanque">{{numeroTanque3}}</div>
                    </div>
                    <div class="Consumidos">Consumos del día: <span class="font500">{{devolverConsumoEnTanque(dispositivoId[0], 3)}} Litros</span></div>
                </div>
                <div class="g-N3 altura-titulo">
                    <canvas id="nivelTanque3"></canvas>
                    <ng-container *ngIf="tanksInfo[2].recargaNecesaria && (userServiceData.pro_id == 4 || userServiceData.pro_id == 2)">
                        <button mat-fab class="recarga-btn" matTooltip="Solicitar Recarga" aria-label="Solicitar Recarga"
                        (click)="solicitarRecarga(tanksInfo[2].tank_id, tanksInfo[2].establishment_id)"
                        [disabled]="waitAfterSave">
                            <mat-icon>autorenew</mat-icon>
                        </button>
                    </ng-container>
                    <div *ngIf ="gaugesCargados" class="datos">{{nivelT3}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Nivel</div>
                </div>
                <div class="g-T3 altura-titulo">
                    <canvas id="temperaturaTanque3"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{temperaturaT3}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Temperatura</div>
                </div>
                <div class="g-P3 altura-titulo">
                    <canvas id="presionTanque3"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{presionT3}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Presion</div>
                </div>
            </div>
            <div class="row-tanque3" *ngIf="verT4">
                <div class="imagen-tanque3">
                    <div *ngIf="imagenCervezaT4 !== null">
                        <img
                            src="{{imagenCervezaT4Url}}" 
                            alt="Tipo de cerveza"
                            class="img-css"
                        />
                    </div>
                    <div *ngIf="imagenCervezaT4 === null" class="not-found-img">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                    <div class="numero-tanque1">
                        <img src="assets/images/tanque-eg.png" alt="Tanque 4" [ngClass]="{'imagen-con-borde': condicionT4Activo}"/>
                        <div class="numero-tanque">{{numeroTanque4}}</div>
                    </div>
                    <div class="Consumidos">Consumos del día: <span class="font500">{{devolverConsumoEnTanque(dispositivoId[0], 4)}} Litros</span></div>
                </div>
                <div class="g-N3 altura-titulo">
                    <canvas id="nivelTanque4"></canvas> 
                    <ng-container *ngIf="tanksInfo[3].recargaNecesaria && (userServiceData.pro_id == 4 || userServiceData.pro_id == 2)">
                        <button mat-fab class="recarga-btn" matTooltip="Solicitar Recarga" aria-label="Solicitar Recarga"
                        (click)="solicitarRecarga(tanksInfo[3].tank_id, tanksInfo[3].establishment_id)"
                        [disabled]="waitAfterSave">
                            <mat-icon>autorenew</mat-icon>
                        </button>
                    </ng-container>
                    <div *ngIf ="gaugesCargados" class="datos">{{nivelT4}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Nivel</div>
                </div>
                <div class="g-T3 altura-titulo">
                    <canvas id="temperaturaTanque4"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{temperaturaT4}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Temperatura</div>
                </div>
                <div class="g-P3 altura-titulo">
                    <canvas id="presionTanque4"></canvas>
                    <div *ngIf ="gaugesCargados" class="datos">{{presionT4}}</div>
                    <div *ngIf ="gaugesCargados" class="datos-titulo">Presion</div>
                </div>
            </div>
        </div>
    </div>

    <div class="graficos-container">
        <div class="graficos-header">
            <span class="consulta-de-historicos">CONSULTA DE HISTÓRICOS</span>
            <div class="consulta-historicos-container">
                <div class="historico-fecha">
                    <h4 class="fecha-titulo">Fecha</h4>
                    <mat-form-field class="fecha-form" color="warn">
                        <mat-label class="color-fecha">Selecciona una fecha</mat-label>
                        <mat-date-range-input
                            [formGroup]="selectedDate"
                            [rangePicker]="selectedDatePicker">
                            <input matStartDate placeholder="Start date" formControlName="start" readonly>
                            <input matEndDate placeholder="End date" formControlName="end" readonly>
                        </mat-date-range-input>
                        <mat-hint>Día/Mes/Año</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" class="color-icon-fecha"></mat-datepicker-toggle>
                        <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="form-container">
                    <h4 class="margin-escala">Escala</h4>
                    <mat-form-field color="warn">
                        <mat-label class="color-fecha">Intervalo de tiempo</mat-label>
                        <mat-select [(ngModel)]="selectedValue" name="escala">
                            <mat-option *ngFor="let escala of escalas" [value]="escala.value">
                                <span *ngIf = "!escalaDias">{{escala.viewValue}}</span>
                                <span *ngIf = "escalaDias">24 Horas</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                        <!--<p> Selected escala: {{selectedValue}} </p>-->
                </div>
                <button mat-flat-button class="exportar-btn" (click)="descargarExcel()" 
                *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-icon class="custom-icon">file_download</mat-icon>
                    Exportar Excel
                </button>
                <button mat-flat-button class="aplicar-btn" (click)="getNewGraphicDate()">Aplicar</button>
            </div>
        </div>

        <div class="graficos-body">
            <!--<h6 class="titulo-nombre-T" style="margin-top: 35px;">Temperatura</h6>-->
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel1" [expanded]="panelEstadisticasAbierto" 
                (closed)="manejarCierrePanel()" (opened)="manejarAperturaPanel()">
                    <mat-expansion-panel-header class="expansion-panel-background">
                        <mat-panel-title class="expansion-tittle">
                            <mat-icon>insert_chart</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Estadísticas Globales</b>
                            </div>
                            <mat-icon>insert_chart</mat-icon>
                          </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (ºC)</div>
                            <div class="temperatura-container-titulo">Máx. (ºC)</div>
                            <div class="temperatura-container-titulo">Media (ºC)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosTemperaturaTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-azul">
                                    <span>{{datosEstadisticosTemperaturaTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-rojo ">
                                    <span>{{datosEstadisticosTemperaturaTodos.maxima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-verde">
                                    <span>{{datosEstadisticosTemperaturaTodos.media}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (Bar)</div>
                            <div class="temperatura-container-titulo">Máx. (Bar)</div>
                            <div class="temperatura-container-titulo">Media (Bar)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosPresionTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-azul">
                                    <span>{{datosEstadisticosPresionTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-rojo ">
                                    <span>{{datosEstadisticosPresionTodos.maxima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-verde">
                                    <span>{{datosEstadisticosPresionTodos.media}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Consumo Total (L)</div>
                            <div class="temperatura-container-titulo">Cañas (0,33 L)</div>
                            <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Dia</div>
                            <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosConsumoTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.total}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.canhas}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhasDia}}</span>
                                </div>
                                <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhas}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel class="expansion-panel1">
                    <mat-expansion-panel-header class="color-expansion">
                      <mat-panel-title class="expansion-tittle">
                        <mat-icon>thermostat</mat-icon>
                        <div class="mat-expansion-tittle-position">
                            <b class="tittle-exp">Temperatura</b>
                        </div>
                        <mat-icon>thermostat</mat-icon>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                
                    <div class="expansion-cont">
                        <ng-container *ngIf="datosEstadisticosTemperatura.length !== 0">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo"></div>
                                <div class="temperatura-container-titulo">Mín. (ºC)</div>
                                <div class="temperatura-container-titulo">Máx. (ºC)</div>
                                <div class="temperatura-container-titulo">Media (ºC)</div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let tanque of datosEstadisticosTemperatura">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo">
                                    <span class="fontS15">{{tanque.nombre}}</span>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-azul">
                                        <span>{{tanque.minima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-rojo ">
                                        <span>{{tanque.maxima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-verde">
                                        <span>{{tanque.media}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <mat-divider *ngIf="datosEstadisticosTemperatura.length !== 0" class="mat-divider2"></mat-divider>
                  </mat-expansion-panel>
            </ng-container>
            
            <div class="grafico-T">
                <div class="g-T">
                    <canvas id="Temperatura"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>
            </div>
            <!--<mat-divider style="width: 90%; margin-right: auto; margin-left: auto;"></mat-divider>-->     
            <div class="grafico-P">
                <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-expansion-panel class="expansion-panel-other">
                        <mat-expansion-panel-header class="color-expansion">
                          <mat-panel-title class="expansion-tittle">
                            <mat-icon>speed</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Presion</b>
                            </div>
                            <mat-icon>speed</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                        <div class="expansion-cont">
                            <ng-container *ngIf="datosEstadisticosPresion.length !== 0">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo"></div>
                                    <div class="temperatura-container-titulo">Mín. (Bares)</div>
                                    <div class="temperatura-container-titulo">Máx. (Bares)</div>
                                    <div class="temperatura-container-titulo">Media (Bares)</div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let tanque of datosEstadisticosPresion">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo">
                                        <span class="fontS15">{{tanque.nombre}}</span>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-azul">
                                            <span>{{tanque.minima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-rojo ">
                                            <span>{{tanque.maxima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-verde">
                                            <span>{{tanque.media}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <mat-divider *ngIf="datosEstadisticosPresion.length !== 0" class="mat-divider2"></mat-divider>
                      </mat-expansion-panel>
                </ng-container>

                <div class="g-P">
                    <canvas id="Presion"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>
            </div>

            <div class="grafico-NC">
                <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-expansion-panel class="expansion-panel-other">
                        <mat-expansion-panel-header class="color-expansion">
                          <mat-panel-title class="expansion-tittle">
                            <mat-icon>trending_up</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Nivel/Consumo</b>
                            </div>
                            <mat-icon>trending_up</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                        <div class="expansion-cont">
                            <div *ngIf="datosEstadisticosConsumo.length !== 0" class="marginTop20">
                                <span class="consumo-tittle">CONSUMO</span>
                            </div>
                            <ng-container *ngIf="datosEstadisticosConsumo.length !== 0">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo"></div>
                                    <div class="temperatura-container-titulo">Consumo Total (L)</div>
                                    <div class="temperatura-container-titulo">Cañas (0.33 L)</div>
                                    <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Día</div>
                                    <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let tanque of datosEstadisticosConsumo">
                                <mat-divider *ngIf="datosEstadisticosConsumo.length >= 1" class="mat-divider1"></mat-divider>
                                <div class="temperatura-container-cont">
                                    <div class="consumo-container-img"> 
                                        <img
                                            src="{{tanque.imagenURL}}"  
                                            alt="Tipo de cerveza"
                                            class="img-css"
                                        />
                                        <span class="consumoTanqueNombre">{{tanque.nombre}}</span>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-amarillo">
                                            <span>{{tanque.total}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-amarillo">
                                            <span>{{tanque.canhas}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo">
                                            <span>{{tanque.ritmoCanhasDia}}</span>
                                        </div>
                                        <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo">
                                            <span>{{tanque.ritmoCanhas}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <mat-divider *ngIf="datosEstadisticosConsumo.length !== 0" class="mat-divider1"></mat-divider>
                        </div>
    
                        <!--<div class="expansion-cont">
                            <div style="margin-top: 20px;" *ngIf="datosEstadisticosNivel.length !== 0">
                                <span style="font-size: 18px; font-weight: 500;">NIVEL</span>
                            </div>
                            <ng-container *ngIf="datosEstadisticosNivel.length !== 0">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo"></div>
                                    <div class="temperatura-container-titulo">Mínima (Litros)</div>
                                    <div class="temperatura-container-titulo">Máxima (Litros)</div>
                                    <div class="temperatura-container-titulo">Media (Litros)</div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let tanque of datosEstadisticosNivel">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo">
                                        <span class="fontS15">{{tanque.nombre}}</span>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo" class="circulo-azul">
                                            <span>{{tanque.minima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-rojo ">
                                            <span>{{tanque.maxima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-verde">
                                            <span>{{tanque.media}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <mat-divider *ngIf="datosEstadisticosNivel.length !== 0" class="mat-divider"></mat-divider>-->
                      </mat-expansion-panel>
                </ng-container>

                <div class="g-NC">
                    <canvas id="Nivel-Consumo"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="header-table">
        <span class="font500">LISTADO DE TANQUES</span>
    </div>
    <div class="bdy-table">
        <table mat-table [dataSource]="dataSource" matSort class="tableTanques" #sort1="matSort">

            <ng-container matColumnDef="nombreTanque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID tanque</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.nombreTanque}} </td>
            </ng-container>

            <ng-container matColumnDef="numero">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº tanque</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.numero}} </td>
            </ng-container>

            <ng-container matColumnDef="espacio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Pos. en Dis.</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.espacio}} </td>
            </ng-container>

            <ng-container matColumnDef="cerveza">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cerveza</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.cerveza}} </td>
            </ng-container>

            <ng-container matColumnDef="capacidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Capacidad (L)</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.capacidad}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver tanque" color="warn" aria-label="Ver tanque" routerLink="/tanque/{{element.id}}">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                    <button *ngIf = "userServiceData.pro_id == 4 || userServiceData.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar tanque" 
                    color="warn" aria-label="Editar tanque" routerLink="/tanques/{{element.id}}/editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsTanques"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsTanques;"></tr>
        </table>
    </div>

    <div class="header-table" *ngIf="hayAlarmasDesactivadas">
        <span class="font500">HISTORICO DE ALARMAS DEL DISPOSITIVO</span>
    </div>
    <div class="bdy-table" *ngIf="hayAlarmasDesactivadas">
        <table mat-table [dataSource]="dataSourceAlarms" matSort #sort3="matSort">

            <ng-container matColumnDef="f_inicio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Inicio </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
            </ng-container>

            <ng-container matColumnDef="f_fin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Fin </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_fin}} </td>
            </ng-container>

            <!--<ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                <td mat-cell *matCellDef="let element" class="cell">
                    <ng-container *ngIf="element.status == 'Desactivada'">
                    <span class="color-gray">{{element.status}} </span>
                    </ng-container>
                    <ng-container *ngIf="element.status == 'Activada'">
                    <span style="color: red;">{{element.status}} </span>
                    </ng-container>
                </td>
            </ng-container>-->

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.type}} </td>
            </ng-container>

            <ng-container matColumnDef="rango">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.rango}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator #paginator1
            [pageSizeOptions]="[10,20,40]"  
            showFirstLastButtons 
            aria-label="Elige una página"
            class="paginator">
        </mat-paginator>
    </div>

    <!--DATOS DISPOSITIVO-->
    <div class="wrap">
        <div class="datos-dispositivo-container">
            <div class="datos-dispositivo-titulo font500">DATOS DISPOSTIVO</div>
            <div class="datos-dispositivo-body">
                <mat-list>
                    <mat-list-item class="list-item">
                        <span class="label">Referencia</span> 
                    </mat-list-item>
                    <mat-list-item class="list-item">
                        <span class="label">Nombre</span> 
                    </mat-list-item>
                    <mat-list-item class="list-item">
                        <span class="label">Fecha de alta</span> 
                    </mat-list-item>                   
                    <mat-list-item class="list-item">
                        <span class="label">Estado</span>   
                    </mat-list-item>
                </mat-list>
                <mat-list>
                    <mat-list-item class="list-item">
                        <span class="valor">{{dev_reference}}</span> 
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">
                        <span class="valor">{{dev_label}}</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">
                        <span class="valor">{{dev_create_at}}</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">   
                        <span class="valor" *ngIf="activado">Activado</span>
                        <span class="valor" *ngIf="!activado">Desactivado</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>
            </div>
            <div class="imagen-dipositivo">
                <img src={{dev_img_path}}>
            </div>
            <div class="editar-btn-container" *ngIf = "userServiceData.pro_id == 4 || userServiceData.pro_id == 1">
                <button mat-flat-button class="editar-btn" routerLink="/{{dev_id}}/editar/dispositivo">Editar</button>
            </div>
        </div>

        <!--UBICACIÓN-->
        <div class="map-container">
            <div class="map-header">
                <span class="font500">UBICACIÓN DEL ESTABLECIMIENTO</span>
            </div>
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid">
                    <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="assets/images/marker.png"></agm-marker>
                </agm-map>-->
                <div id="map" class="mapHeight"></div>
        </div>
    </div>

    <div class="footer"></div>
</ng-template>